<script>
import axios from "axios";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import { todoMethods, todoComputed } from "@/state/helpers";

import { tableData } from "../dataAdvancedtable";

/**
 * Dashboard Component
 */
export default {

  page: {
    title: "Empresas",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      checked: true,
     label: "",
      active: 1,
      dataOn: "On",
      dataOff: 'Off',


// ************************************** Link
      tableData: tableData,
      title: "Nueva Punto de Entrega",
      items: [
        {
          text: "Puntos de entrega",
          href: "/PuntosEntrega",
        },
        {
          text: "Nuevo Punto de Entrega",
          active: true,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      options: ["Empresa","Diferente"],
      objeto:{
        estatus: true
      }

    };
  },

   computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },

  mounted() {

    this.checked = Boolean(this.active);
    // Podemos reutilizar la función update ya que el código es el mismo.
    this.update();

    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;

    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },

    methods: {

    update() {
      this.label = this.checked ? this.dataOn : this.dataOff;
    },
    ...todoMethods,
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor (estado) {
        if (estado == "Activo") return 'red'
        else return 'green'
      },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },
    cancelar(){
      this.$router.push({
        name:'PuntosEntrega'
      });
    },
    handleSubmit(){
      this.objeto.estatus = this.objeto.estatus === true ? 1 : '0';
      axios.post('https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/puntos_entrega',this.objeto)
      .then((res) => {
        const {response=""} = res.data;
        if (response === true) {
          this.$swal(
            'Registro',
            'Registro creado exitosamente',
            'success'
          );
          this.$router.push({name:'PuntosEntrega'});
        } else {
          this.$swal(
            'Alerta',
            'No se pudo crear',
            'warning'
          );
        }
      })
      .catch(err => {
        console.log(err);
        this.$swal(
          'Error',
          'Ocurrio un error',
          'error'
        );
      });
    }

    
    
  },


};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  
 <div class="row">
    <div class="col-lg-12">
           <v-card>
       <div class="card-body">
      <div class="row mt-4">
        <div class="col-sm-12 col-md-12">   
          <h4 class="card-title">Nuevo Punto de Entrega</h4>
           </div>

</div>

 <div class="row mt-4">
   <div class="col-sm-12 col-md-5">
          <b><label class="form-check-label " >Nombre del punto de entrega</label></b> 
          <div class="mb-4">
            <b-form-input 
              v-model="objeto.nombre"
              id="nombre"
              placeholder="Nombre del punto de entrega"
            ></b-form-input>
          </div>
        </div>
        <div class="col-sm-12 col-md-5">
          <b><label class="form-check-label " >Tipo</label> </b>
          
          <div class="mb-4">
            <b-form-select
              class="form-select"
              v-model="objeto.tipo"
              size="lg"
            >
              <option 
                v-for="option in options" 
                :key="option.index" 
                :value="option"
                >{{option}}
              </option>
            </b-form-select>
          </div>
        </div> 
        <div class="col-sm-12 col-md-1"> </div>
   <div class="col-sm-12 col-md-1">
   <b>  <label class="form-check-label " 
        >Estado  </label> </b>
      <br> <br>
 <label class="switch" role="button">
   <input
     type="checkbox"
     :value="objeto.estatus"
     v-model="objeto.estatus"
     @change="update"
   />
   <div
     class="circle"
     :class="{
       'circle-on': objeto.estatus,
       'circle-off': !objeto.estatus
     }"
   >
     <span>{{ label }}</span>
   </div>
 </label>
        </div>  </div> 

      
 <v-row>
    <v-col md="12"> 
        <v-btn
        color="primary"
        type="button"
        v-on:click="handleSubmit();"
        >
        Guardar
        </v-btn> 
        <v-divider
        class="mx-1"
        inset
        vertical
        ></v-divider>
        <!-- <router-link to="/Categorias"> -->
        <v-btn 
        color="error"
        type="button"
        @click="cancelar()"
        >
        Cancelar
        </v-btn>
        <!-- </router-link> -->
    </v-col>
  </v-row>


</div>

      </v-card>
    </div>
  </div>

  </Layout>
 
</template>

<style lang="scss">
$default: black;
$active: #2dc772;
$inactive: #6c757d;
$text: #9d9d9d;
$text-hover: white;
$size: 0.7rem;
$w: 60px;
$h: 25px;
$circle: $h - 4;
$toggle-dis: $w - $circle - 2;

.switch {
    position: relative;
    display: inline-block;
    width: $w;
    height: $h;
    border-radius: 100px;

    .circle {
        display: flex;
        align-items: center;
        width: 100%;
        height: $h - 1;
        border-radius: 100px;
        background-color: $default;

        & > span {
            font-size: $size;
            color: $text;
            padding-left: $h + -6;
        }

        &::before {
            position: absolute;
            content: "";
            height: $circle;
            width: $circle;
            left: 1px;
            top: 1px;
            border-radius: 100px;
            background-color: white;
            -webkit-transition: 0.4s;
            transition: 0.4s;
        }

        &:hover {
            background-color: lighten($default, 20);

            & > span {
                color: $text-hover;
            }
        }
    }

    .circle-on {
        background-color: $active;

        & > span {
            color: white;
        }

        &:hover {
            background-color: white;
            border: 1px $active solid;

            &::before {
                background-color: $active;
            }

            & > span {
                color: $active;
            }
        }
    }

    .circle-off {
        background-color: $inactive;

        & > span {
            color: white;
        }

        &:hover {
            background-color: white;
            border: 1px $inactive solid;

            &::before {
                background-color: $inactive;
            }

            & > span {
                color: $inactive;
            }
        }
    }

    & input {
        display: none;

        &:checked + .circle:before {
            -webkit-transform: translateX($toggle-dis);
            -ms-transform: translateX($toggle-dis);
            transform: translateX($toggle-dis);
        }
    }
}
</style>